module.exports = __webpack_public_path__ + "img/rule_bg.f7811442.jpg";